export const CLICK_RUN_CODE_BUTTON = 'click_run_code_button';
export const USE_RUN_CODE_SHORTCUT = 'use_run_code_shortcut';
export const TOGGLE_LIGHT_DARK_THEME = 'toggle_light_dark_theme';
export const CLICK_COPY_EVENTS_BUTTON = 'click_copy_events_button';
export const CLICK_COPY_LOGS_BUTTON = 'click_copy_logs_button';
export const CLICK_CLEAR_EVENTS_BUTTON = 'click_clear_events_button';
export const CLICK_CLEAR_LOGS_BUTTON = 'click_clear_logs_button';
export const CLICK_COPY_CODE_BUTTON = 'click_copy_code_button';
export const CLICK_CLEAR_CODE_BUTTON = 'click_clear_code_button';
export const CLICK_FORMAT_BUTTON = 'click_format_button';
export const CLICK_FULL_SCREEN_BUTTON = 'click_full_screen_button';
export const TOGGLE_EVENTS_PANEL = 'toggle_events_panel';
export const TOGGLE_OPERATIONS_MENU = 'toggle_operations_menu';
export const CLICK_PLAYGROUND_USER_MANUAL_LINK = 'click_playground_user_manual_link';
export const CLICK_EMBEDDING_SDK_DOCUMENTATION_LINK = 'click_embedding_sdk_documentation_link';
export const CLICK_LOGOUT_BUTTON = 'click_logout_button';
export const FOCUS_OPERATIONS_MENU_SEARCH_BAR = 'focus_operations_menu_search_bar';
export const CLICK_EVENTS_TAB = 'click_events_tab';
export const CLICK_CONSOLE_TAB = 'click_console_tab';
export const USE_DEMO_EXAMPLES = 'use_demo_examples';
export const USE_CUSTOM_DOSSIER = 'use_custom_dossier';
export const CLICK_ADD_CODE_BUTTON = 'click_add_code_button';
export const DRAG_OPERATION_ITEM = 'drag_operation_item';
export const RESIZE_PANEL = 'resize_panel';
export const COLLAPSE_PANEL = 'collapse_panel';
export const EXPAND_PANEL = 'expand_panel';
export const RESIZE_CODE_PANEL_AND_EVENT_PANEL_LABEL = 'resize code panel and event panel';
export const RESIZE_PREVIEW_PANEL_LABEL = 'resize preview panel';
export const COLLAPSE_EXPAND_EVENT_PANEL_LABEL = 'event panel';
export const COLLAPSE_EXPAND_OPERATIONS_MENU_LABEL = 'operations menu';
export const USE_DEMO_EXAMPLES_FROM_LINK = 'use_demo_examples_from_link';
export const CLICK_LINK_EXAMPLE_BUTTON = 'click_link_example_button';
export const CLICK_WELCOME_IN_USER_MENU = 'click_welcome_in_user_menu';
export const CLICK_TAKE_A_TOUR_IN_USER_MENU = 'click_take_a_tour_in_user_menu';
export const SKIP_IN_WELCOME_ONBOARDING = 'skip_in_welcome_onboarding';
export const SKIP_IN_TOUR_ONBOARDING = 'skip_in_tour_onboarding';
export const NAVIGATE_WITH_PROGRESS_BAR_IN_WELCOME_ONBOARDING =
  'navigate_with_progress_bar_in_welcome_onboarding';
export const NAVIGATE_WITH_PROGRESS_BAR_IN_TOUR_ONBOARDING =
  'navigate_with_progress_bar_in_tour_onboarding';
export const NAVIGATE_WITH_BUTTON_IN_WELCOME_ONBOARDING =
  'navigate_with_button_in_welcome_onboarding';
export const NAVIGATE_WITH_BUTTON_IN_TOUR_ONBOARDING = 'navigate_with_button_in_tour_onboarding';
export const NAVIGATE_WITH_ARROW_IN_WELCOME_ONBOARDING =
  'navigate_with_arrow_in_welcome_onboarding';
export const NAVIGATE_WITH_ARROW_IN_TOUR_ONBOARDING = 'navigate_with_arrow_in_tour_onboarding';
export const FINISH_ONBOARDING_EXPERIENCE = 'finish_onboarding_experience';
